import { initialize } from 'launchdarkly-react-client-sdk';
import { LAUNCH_DARKLY_CLIENT_ID } from 'constants/launchDarkly';
import type { LDFlags } from 'store/launchDarkly/types/flags';

export const initializeLaunchDarkly = (clientId: string, countryCode: string): Promise<LDFlags> => {
  return new Promise((resolve, reject) => {
    const client = initialize(LAUNCH_DARKLY_CLIENT_ID, { key: clientId.toString(), country: countryCode });

    client.on('ready', () => {
      const flags = Object.entries(client.allFlags()).reduce(
        ({ keys, values }: LDFlags, [key, value]) => {
          return {
            keys: keys.concat(key),
            values: values.concat({ value })
          };
        },
        { keys: [], values: [] }
      );

      resolve(flags);
    });
    client.on('failed', reject);
    client.on('error', reject);
  });
};
